import { render, staticRenderFns } from "./Item-single.vue?vue&type=template&id=5da5a954&scoped=true&lang=pug"
import script from "./Item-single.vue?vue&type=script&lang=js"
export * from "./Item-single.vue?vue&type=script&lang=js"
import style0 from "./Item-single.vue?vue&type=style&index=0&id=5da5a954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5a954",
  null
  
)

export default component.exports